<rask-multi-selector class="grid-multiselect-fit"
    [rule]="rule"
    [items]="values"
    [bindLabel]="multiselectorBindLabel"
    [bindValue]="multiselectorBindValue"
    [selected]="value"
    [(ngModel)]="value"
    [portalToBody]="false"
    [disabled]="readonly"></rask-multi-selector>
